import { memo } from 'react';
import Router from 'next/router';
import { useReduxState } from 'hooks';
import api from 'api';
import { useApiData } from 'lib/api';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Select } from 'components/common/form';

import type { Course } from 'shared-types';
import type { EditorHeaderStateProps } from './EditorHeader';

type Props = Pick<EditorHeaderStateProps, 'currentChapter'>;

const EditorHeaderCopy = ({ currentChapter }: Props) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const { data: editableCoursesData } = useApiData({
    url: '/admin/courses-administered?permission=edit-content'
  });

  const editableCourses: Pick<Course, 'id' | 'title'>[] =
    editableCoursesData?.courses || [];

  const submit = async (values: typeof initialValues) => {
    const response = await api.post(
      `/admin/courses/${course.id}` + `/chapters/${currentChapter.id}/copy`,
      values
    );

    const newChapter = response.data.chapter;
    Router.push(
      '/admin/courses/[courseSlug]/edit/[chapterSlug]',
      `/admin/courses/${newChapter.courseSlug}/edit/${newChapter.slug}`
    );
    return true;
  };

  const initialValues = { newCourseId: course.id };

  return (
    <ModalButtonWithForm
      buttonIcon={['far', 'copy']}
      buttonIsDropdown={true}
      buttonText={messages.coursesCopyChapter}
      initialValues={initialValues}
      modalActionText={messages.commonCopy}
      modalTitle={messages.coursesCopyChapter}
      onSubmit={submit}
    >
      {() => (
        <FormGroup
          htmlFor="new-course-id"
          label={messages.coursesCopyChapterLabel}
        >
          <Select
            field="newCourseId"
            id="new-course-id"
            isSearchable={true}
            options={editableCourses.map((course) => ({
              label: course.title,
              value: course.id
            }))}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default memo(EditorHeaderCopy);
